import { render, staticRenderFns } from "./InspectionRecordAdd.vue?vue&type=template&id=45ab630f&scoped=true"
import script from "./InspectionRecordAdd.vue?vue&type=script&lang=js"
export * from "./InspectionRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./InspectionRecordAdd.vue?vue&type=style&index=0&id=45ab630f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab630f",
  null
  
)

export default component.exports